<script lang="ts">
    import { fly } from "svelte/transition";
    import { userIsAdminStore, limitMapStore, bannerStore } from "../../Stores/GameStore";
    import { ADMIN_URL } from "../../Enum/EnvironmentVariable";
    import { LL } from "../../../i18n/i18n-svelte";
    import { warningBannerStore } from "../../Stores/MenuStore";

    /* eslint-disable svelte/no-at-html-tags */

    const registerLink = ADMIN_URL + "/second-step-register";

    function closeBanner() {
        warningBannerStore.set(false);
        bannerStore.set(null);
    }
</script>

<main
    class="warningMain flex justify-center absolute bottom-4 left-4 right-4 pointer-events-auto"
    transition:fly={{ y: 200, duration: 500 }}
>
    <div
        class="overflow-hidden rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)]"
    >
        {#if $bannerStore != undefined}
            <div id={$bannerStore.id} class="m-0 p-4 flex justify-center items-center relative">
                <div class="relative z-10 text-lg pl-2" style={`color: ${$bannerStore.textColor};`}>
                    {$bannerStore.text}&nbsp;
                    {#if $bannerStore.link}
                        <a
                            class=" underline"
                            style={`color: ${$bannerStore.textColor};`}
                            href={$bannerStore.link.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {$bannerStore.link.label}
                        </a>
                    {/if}
                </div>
                <div
                    class="absolute z-0 h-full w-full {$bannerStore.bgColor
                        ? ''
                        : 'bg-[var(--nutrivera-shell-raised)]'}"
                    style={`background-color:${$bannerStore.bgColor};`}
                ></div>
                {#if $bannerStore.closable}
                    <button
                        class="btn relative z-10 ml-4 rounded-[9px] border border-solid border-current !py-1 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--nutrivera-shell-accent)]"
                        style={`color: ${$bannerStore.bgColor};background:${$bannerStore.textColor};`}
                        onclick={(event) => {
                            event.preventDefault();
                            closeBanner();
                        }}
                    >
                        {$LL.actionbar.understand()}
                    </button>
                {/if}
            </div>
        {:else if $userIsAdminStore}
            <h2>{$LL.warning.title()}</h2>
            <p>{@html $LL.warning.content({ upgradeLink: ADMIN_URL + "/pricing" })}</p>
        {:else if $limitMapStore}
            <p>
                This map is available for 2 days. You can register your domain <a href={registerLink}>here</a>!
            </p>
        {:else}
            <h2>{$LL.warning.title()}</h2>
            <p>
                {@html $LL.warning.content({ upgradeLink: ADMIN_URL + "/pricing" })}
            </p>
        {/if}
    </div>
</main>
